import React, { FC, useState } from 'react';

import Layouts from '../../layout';
import Features from '../../pagesComponents/MainPage/Features';
import SectionTitle from '../SectionTitle';
import TextDescription from '../TextDescription';
import FixedButton from '../FixedButton';
import { Link } from 'gatsby';

import Button from '../Button';
import arrowDown from '../../../assets/img/arr-down.png';
import arrowTop from '../../../assets/img/arr-top.png';
import arrowRight from '../../../assets/img/arr-right.svg';
import './BlogArticle.scss';
import arrRight from '../../../assets/img/arr-right.svg';

interface BlogArticleProps {
    title: string;
    subtitle?: string;
    image: any;
    author: string;
    date: string;
    blogData: any;
    contentData?: any;
}

const BlogArticle: FC<BlogArticleProps> = (props) => {
    const [showFullArticle, setShowFullArticle] = useState<boolean>(false);
    const options = props.blogData;
    const SHOW_BY_DEFAULT: number = 2;
    const visibleOptions = showFullArticle ? options.length : SHOW_BY_DEFAULT;

    const toggleArticle = () => {
        setShowFullArticle(!showFullArticle);
    };

    const handleScroll = (data) => {
        setShowFullArticle(true);

        window.requestAnimationFrame(() => {
            const el = document.getElementById(data.text);
            const yOffset = -80;
            const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        });
    };

    return (
        <Layouts>
            <section className="blog-articles__wrapper">
                <div className="blog-articles__header">
                    <div className="blog-articles__nav">
                        <TextDescription subtype="blog-category">NEWS & UPDATES</TextDescription>
                        <Link to="/blog/">
                            <Button type="watch" desc="View All Posts" icon={arrRight}>
                                View All Posts
                            </Button>
                        </Link>
                    </div>

                    <SectionTitle type="primary" title={props.title} />
                    <div className="blog-articles__content">
                        <div className="blog-articles__content-title">
                            <SectionTitle type="margin" title="Table of Contents" />
                        </div>
                        {props.contentData.map((data) => (
                            <a
                                className="blog-articles__content-link"
                                onClick={() => handleScroll(data)}
                            >
                                <TextDescription type="margin-content" subtype="blog-content">
                                    {data.text}
                                </TextDescription>
                            </a>
                        ))}
                    </div>
                </div>
                <div className="blog-articles__content">
                    {props.blogData.slice(0, visibleOptions).map((blog) => (
                        <div
                            id={blog.scrollId || blog.title}
                            key={blog.id}
                            className="blog-articles__item"
                        >
                            <SectionTitle type="blog" title={blog.title} />
                            {blog.subtitle ? (
                                <SectionTitle type="blog-subtitle" title={blog.subtitle} />
                            ) : null}
                            <TextDescription type={blog.type} subtype={blog.subtype}>
                                {blog.text}
                            </TextDescription>
                        </div>
                    ))}
                </div>
                <div className="blog-articles__btn" onClick={toggleArticle}>
                    <Button
                        icon={!showFullArticle ? arrowDown : arrowTop}
                        type="primary"
                        desc="Show full article"
                    >
                        {!showFullArticle ? 'Read more' : 'Hide'}
                    </Button>
                </div>
                <div className="blog-articles__info">
                    <span className="blog-articles__author">{props.author}</span>
                    <span className="blog-articles__date">{props.date}</span>
                </div>
            </section>
            <div className="blog-articles__form">
                <Features
                    localLink={true}
                    globalLink={false}
                    buttonIcon={arrowRight}
                    title="More details on our service delivery and how we set up to success"
                    buttonText="Discover all"
                />
            </div>
            <FixedButton />
        </Layouts>
    );
};

export default BlogArticle;
